export default [
  {
    name: 'Home',
    path: '/'
  },
  {
    name: 'WhatWeDo',
    path: '/smart-venues'
  },
  // {
  //   name: 'WhoAreWe',
  //   path: '/who-are-we'
  // },
  // {
  //   name: 'WhatWeDo',
  //   path: '#',
  //   children: [
  //     {
  //       name: 'SmartVenues',
  //       path: '/smart-venues'
  //     },
  //     {
  //       name: 'SmartConstruction',
  //       path: '/smart-construction'
  //     }
  //   ]
  // },
  // {
  //   name: 'Solutions',
  //   path: '/solutions',
  //   children: [
  //     {
  //       name: 'Construction',
  //       path: '/construction'
  //     },
  //     {
  //       name: 'Retail',
  //       path: '/retail'
  //     },
  //     {
  //       name: 'HealthCare',
  //       path: '/health-care'
  //     },
  //     {
  //       name: 'EventVenues',
  //       path: '/event-venues'
  //     },
  //     {
  //       name: 'Transportation',
  //       path: '/transportation'
  //     },
  //     {
  //       name: 'Hospitality',
  //       path: '/hospitality'
  //     }
  //   ]
  // },
  // {
  //   name: 'Platforms',
  //   path: '/platforms'
  // },
  // {
  //   name: 'OurClient',
  //   path: '/our-client'
  // },
  // {
  //   name: 'HowItWorks',
  //   path: '/how-it-works'
  // },
  // {
  //   name: 'IMDF',
  //   path: '/imdf'
  // },
  {
    name: 'Contacts',
    path: '/contacts'
  }
  // {
  //   name: 'OurTeam',
  //   path: '/our-team'
  // }
]
